import type { ReactNode } from 'react'
import type { CommentHubRole } from 'shared-code/commenthub-api'
import type { CommentHubRoleBadgeContext } from 'shared-components/contexts/CommentHubAPIContext'
import { isTeamRole } from 'lib/community/discussions'
import TeamPill from './discussions/TeamPill'

/**
 * SoundGuys' badge for a comment author's commentHub role (`CommentHubAPIContext` `roleBadge`,
 * 2026-10-23): a team role (moderator, admin, staff) wears the SOUNDGUYS TEAM pill on every
 * comment surface — article comments, discussion answers, owner-review replies; any other role
 * draws nothing. commentHub's role is THE source: the team's writers and admins sign in and
 * comment without ever claiming a DealHunt owner profile, so DealHunt's `staff_hashes` could not
 * name them (Adam Birney, 2026-10-23). The raw role word ("Admin") is never shown on SoundGuys.
 * In the conversation panel (`layout: 'panel'`) the pill is the small one: the design keeps the
 * name line light, and the answer-size pill was the loudest thing in it (2026-10-24).
 */
export function teamRoleBadge(
  role: CommentHubRole,
  context?: CommentHubRoleBadgeContext
): ReactNode {
  if (!isTeamRole(role)) {
    return null
  }
  return <TeamPill size={context?.layout === 'panel' ? 'small' : 'answer'} />
}
